import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import { ChartInner } from './ChartInner/ChartInner';
import { ProspectData } from '@/types/salesforce';

export type ChartProps = SliceComponentProps<Content.ChartSlice, ProspectData>;

const Chart = ({ slice, context }: ChartProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <ChartInner
        data={slice.primary}
        variation={slice.variation}
        prospect={context}
      />
    </section>
  );
};

export default Chart;
